import {fetchPatch, generateEndpoint} from "../../../utils/request";

export const updateGuest= async({ token, guest }) => {
  const url = `${generateEndpoint('updateGuest')}`
  return fetchPatch(url, token, { guest })
}
